import React, { useState, useEffect, useRef } from 'react'

interface MyTextAreaProps {
  minLines: number
  placeholder: string
  value: string
  minLength: number
  maxLength: number
  onChange: (
    e:
      | React.ChangeEvent<HTMLTextAreaElement>
      | React.ChangeEvent<HTMLInputElement>,
  ) => void
  className?: string
}

const MyTitleArea: React.FC<MyTextAreaProps> = ({
  minLines,
  placeholder,
  value,
  minLength,
  maxLength,
  onChange,
  className,
}) => {
  const [currentValue, setCurrentValue] = useState(value)
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
    }
  }, [currentValue])

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLTextAreaElement>
      | React.ChangeEvent<HTMLInputElement>,
  ) => {
    setCurrentValue(e.target.value)
    onChange(e)
  }

  const inputClassName = `my-inputarea ${className || ''}`
  const textareaClassName = `my-textarea ${
    className || ''
  } focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-redpink`

  return (
    <div className='relative my-textarea-container w-full border-2 border-anthracite rounded-b-md mb-8'>
      <textarea
        ref={textareaRef}
        className={textareaClassName}
        rows={minLines}
        placeholder={placeholder}
        value={currentValue}
        onChange={handleChange}
        maxLength={maxLength}
        style={{ overflow: 'hidden', width: '100%' }}
      />
      {(minLength > 0 || maxLength) && (
        <div
          className={`absolute right-2 bottom-2 text-xs ${
            maxLength && currentValue.length >= maxLength
              ? 'text-redpink'
              : currentValue.length < minLength
              ? 'text-redpink'
              : 'text-gray-500'
          }`}
        >
          {currentValue.length}
          {minLength > 0 && ` / ${minLength}`}
          {maxLength && ` (max ${maxLength})`}
        </div>
      )}
    </div>
  )
}

export default MyTitleArea
